module.exports = __webpack_public_path__ + "src/img/artist/indexpic08.jpg?543d6fc9dead57078dbb731964d24c18";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/indexpic08.jpg
// module id = 135
// module chunks = 0